import React from "react";

/**
 * The phone numbers the credit bureau holds for this customer.
 *
 * These are the one thing the customer has to act on, but they used to sit mid-sentence in a
 * paragraph of body text — on a phone that meant scanning three lines of prose to find five
 * digits. Lifting them out makes them the anchor of the screen.
 *
 * Styling deliberately stays minimal and borrows from the surrounding journey rather than
 * introducing a card of its own: square corners and a thin border, matching `TelField`
 * (`border ... rounded-none h-14`) directly below it. No tint, no shadow, no radius — the rest
 * of these screens are white space and typography, and a filled rounded card read as heavier
 * than everything around it.
 */
export default function BureauNumbersCard({ hints, theme }) {
  if (!hints?.length) return null;

  const isMultiple = hints.length > 1;

  return (
    <div className="w-full flex flex-col gap-2">
      <span
        className={`text-3xs uppercase tracking-wider ${
          theme?.textColor ?? "text-gray-500"
        }`}
      >
        {/* One line, not two: for a single number this labels it, and for several it doubles as
            the instruction — saving a separate "enter whichever you recognise" helper line. */}
        {isMultiple
          ? "Enter whichever of these you recognise"
          : "Number on your credit record"}
      </span>

      <div className="flex flex-wrap gap-2">
        {hints.map((hint) => (
          <span
            key={hint}
            className={`border ${
              theme?.borderColor ?? "border-gray-300"
            } px-3 py-2 text-sm font-semibold tracking-wider rounded-none ${
              theme?.darkTextColor ?? "text-gray-800"
            }`}
          >
            <span className="opacity-30">•••••</span>
            {hint}
          </span>
        ))}
      </div>
    </div>
  );
}
